// extracted by mini-css-extract-plugin
module.exports = {"slideBar":"_2oQj1wUNaBOrzekqVnv-Ci"};